import React from 'react'
import { withRouter } from "react-router-dom";
// import TableComponent, { TableOp } from '../table/TableOps';
import { Dialog, DialogContentText, DialogTitle, DialogActions, DialogContent, Button } from '@material-ui/core';
import Http from '../../../Http';
import TableComponent, { TableOp } from '../../../components/table/TableOps';
import ACCESS from '../../../ACCESS';
// import Http from '../../Http';

class PendientesCyc extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'guia/confirmarCYC', deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table('Guías Pendientes por confirmar CYC', [
        { label: 'Folio', id: 'g_folio' },
        { label: 'Fecha', id: 'g_fecha' },
      ], [
        { id: 'approve', icon: 'lock', tooltip: 'Aprobar', access: [ACCESS.GUIAS_PENDIENTES_CYC.APROVAR_GUIA] },
      ]))
    this.table();
  }

  action = (id, row) => {
    if (id === 'approve') {
      this.setState({ dRow: row, desOpen: true });
    }
  }

  autorizar = async (op) => {
    if (op) {
      try {
        let Res = await Http.post(`guia/${this.state.dRow.id}/autorizarcyc`, {});
        if (!Res.error) {
          this.table();
          this.setState({ desOpen: false })
        }
      } catch (error) {
        this.setState({ desOpen: false })
      }
      return;
    }
    this.setState({ desOpen: false });
  }

  render() {
    const { dRow, desOpen } = this.state;
    return (
      <div>
        <div style={{ padding: 20 }}>
          <this.TableRender />
        </div>

        <div>
          <Dialog
            open={desOpen ? desOpen : false}
            onClose={() => this.setState({ desOpen: false })}
          >
            <DialogTitle>Aprobar Guia</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Se va a marcar como <span style={{ fontWeight: 'bold' }}>aceptada</span> la guía #{dRow ? dRow.g_folio : ''} y ya se podra embarcar
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.autorizar(false)} color="primary">
                No
              </Button>
              <Button onClick={() => this.autorizar(true)} color="primary" autoFocus>
                Sí
            </Button>
            </DialogActions>
          </Dialog>
        </div>

      </div>
    )
  }
}

export default withRouter(PendientesCyc)